import type { PetAttribute, PetStatusEffect, PetEvolutionStage } from '../pet';
import type { Widen } from 'src/replicant/utils/types';
import CareItemData from '../../airtable/CareItem';

export type CareItem = typeof CareItemData[number];
export type CareItemType = CareItem['type'];
export type CareActionType = 'bath' | 'toilet';
export type DuoItem = 'i_vowsCoffee' | 'i_ultimateVowsCoffee';

export const careItems = CareItemData.reduce((acc, item) => {
  acc[item.id] = item;
  return acc;
}, {} as Record<CareItem['id'], CareItem>);

export const careTypeItems = CareItemData.reduce((acc, item) => {
  if (!acc[item.type]) {
    acc[item.type] = [];
  }
  acc[item.type].push(item);
  return acc;
}, {} as Record<CareItemType, CareItem[]>);

export function getCareItemAmount(
  careItem: Widen<CareItem>,
  attribute: PetAttribute,
) {
  switch (attribute) {
    case 'love': {
      return careItem.love;
    }
    case 'stomach': {
      return careItem.stomach;
    }
    case 'toothAcidity': {
      return careItem.tooth_acidity;
    }
    default: {
      return 0;
    }
  }
}

export function getCareItemCureChance(
  careItem: Widen<CareItem>,
  statusEffect: PetStatusEffect,
  resolutionAttempts: number,
) {
  switch (statusEffect) {
    case 'sick': {
      return careItem.sick_cure_chance;
    }
    case 'dying':
      return careItem.dying_cure_chance;

    case 'toothDecay': {
      return careItem.tooth_decay_cure_chance;
    }
    case 'scared': {
      if (resolutionAttempts > 1) {
        return 1;
      }
      return resolutionAttempts > 0 ? 0.8 : 0.4;
    }
    default: {
      return 0;
    }
  }
}

export const getCareItems = (type: CareItemType, stage: PetEvolutionStage) => {
  const items = careTypeItems[type];
  return items.filter((item) => item.stages.match(stage));
};
